module.exports = __webpack_public_path__ + "img/nav_icon_home_normal.613c199f.png";